import { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Row,
  Collapse,
  Button,
} from "reactstrap";
// router
import { useLocation } from "react-router-dom";
// componentes
import GameChart from "./Chart";
import Pagination from "../../../components/Paginationv3";
import SearchFilters from "../../../components/SearchFilters";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import WaitExport from "../../../components/WaitExport";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// service e utils
import { getList, getChartData } from "../../../utils/services/gameRd";
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";
import { listGroups, listGroupsEvent9d } from "../../../utils/mocks/gameRd";
// moment
import moment from "moment/moment";

export default function GameRD() {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  const nameEvent = location.state.event.title;
  // collapse
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dataList, setDataList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const [activeFilter, setActiveFilter] = useState("name");
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // dados do grafico
  const [chartData, setChartData] = useState([]);
  // loading
  const [isLoading, setIsLoading] = useState(false);

  const columnsFilter = [
    { name: "Nome do Participante", value: "name", type: "text" },
    { name: "Email do Participante", value: "email", type: "text" },
    { name: "Estande", value: "code", type: "text" },
    { name: "Grupo", value: "group", type: "text" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  async function getListData() {
    setIsLoading(true);
    try {
      const apiData = {
        idEvent: idEvent,
        offset: currentIndex,
        limit: itemsPerPage,
        search: debouncedSearch,
        columnSearch: activeFilter,
      };

      const res = await getList(apiData);

      setCountData(res.total);
      setDataList(res.data);
    } catch (error) {
      // console.log("get erro", error);
      setCountData(0);
      setDataList([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function getChart() {
    try {
      const res = await getChartData({ idEvent });

      setChartData(res.data);
    } catch (error) {
      // console.log('get chart error', error)
      setChartData([]);
    }
  }

  // função para exibir apenas grupos da lista fixa
  function getGroups(groups) {
    var groupsFilter = [];

    var groupsSearch = [];

    switch (idEvent) {
      case "4162ddc1-1c76-47ef-b5bb-75a6f377d104":
        groupsSearch = listGroups;
        break;
      case "9d589e40-af6d-41fc-b01d-0df3bfc174d6":
        groupsSearch = listGroupsEvent9d;
        break;
      default:
        groupsSearch = [];
    }

    groups.map((group) => {
      const search = groupsSearch.find((e) => e.id === group.id);

      if (search) {
        groupsFilter.push(search);
      }
    });

    return groupsFilter;
  }

  useEffect(() => {
    getListData();
  }, [debouncedSearch, itemsPerPage, currentIndex]);

  useEffect(() => {
    getChart();
  }, []);

  return (
    <>
      <WaitExport
        isOpen={exportInProgress}
        name="Game RD Estandes"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      <Card>
        <CardBody>
          <CardTitle>Game RD Estandes</CardTitle>

          <GameChart chartData={chartData} />

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form className="app-search" style={{ padding: "0px" }}>
                  <div className="position-relative">
                    <input
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              {dataList.length > 0 && (
                <>
                  <SectionComponent
                    sectionName="Opções"
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                  />

                  <Collapse isOpen={isOpen}>
                    <Row className="mobile-btns-top">
                      <div
                        onClick={() =>
                          createXlsx({
                            idEvent: idEvent,
                            nameEvent: nameEvent,
                            limit: 999999,
                            countData,
                            setFinishExport,
                            getGroups,
                          }) > setExportInProgress(true)
                        }
                      >
                        Exportar Relatório
                      </div>
                    </Row>
                  </Collapse>
                </>
              )}
            </div>

            <div className="header-btns-container">
              {dataList.length > 0 && (
                <>
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light events-button-add"
                    onClick={() =>
                      createXlsx({
                        idEvent: idEvent,
                        nameEvent: nameEvent,
                        limit: 999999,
                        countData,
                        setFinishExport,
                        getGroups,
                      }) > setExportInProgress(true)
                    }
                  >
                    Exportar Relatório
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome do Participante</th>
                  <th>Email do Participante</th>
                  <th>Grupo(s)</th>
                  <th>Estande</th>
                  <th>Data e Hora</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : (
                  dataList &&
                  dataList.length > 0 &&
                  dataList.map((e, i) => (
                    <tr key={i}>
                      <td>{e.participante}</td>
                      <td>{e.email}</td>
                      <td>
                        {getGroups(e.grupos)
                          ?.map((grp) => {
                            return grp.name;
                          })
                          .join(", ")}
                      </td>
                      <td>{e.description}</td>
                      <td>
                        {moment(e.created_at).format("DD/MM/YYYY H:mm:ss")}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation"
        style={{
          justifyContent: "end",
        }}
      >
        <Pagination
          data={dataList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}
